import { PageViewEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import Layout from '@/components/layout/Layout';
import { CancelReasonContent } from '@/components/tax-refund/cancel/CancelReasonContent';
import { COMMON_PATHS } from '@/lib/constants/paths';
import { cancelDataAtom } from '@/lib/stores/cancel-data';

const CorporationCancelReasonPage = () => {
  const router = useRouter();
  const cancelData = useAtomValue(cancelDataAtom);
  const { showDialog } = useDialog();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current && cancelData && cancelData.businessType !== 'corps') {
      showDialog({
        title: '비정상적인 접근입니다.'
      });
      router.push({ pathname: COMMON_PATHS.환급신청결과, query: { type: 'corps' } });
      isMounted.current = true;
    }
  }, [cancelData, router, showDialog]);

  return (
    <AuthGuard>
      <PageViewEventLogger pageName={'corps-cancel_reason'} />
      <Layout leftIcon={{ icon: 'back', clickEvent: { name: 'corps-cancel_topnav_back' } }}>
        {cancelData?.refundId && (
          <CancelReasonContent
            refundId={cancelData?.refundId ?? ''}
            name={cancelData?.name ?? ''}
            resultPath={COMMON_PATHS.환급신청결과}
            businessType="corps"
          />
        )}
      </Layout>
    </AuthGuard>
  );
};

export default CorporationCancelReasonPage;
